import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { AmountInput } from '../../../elements/Input/Amount';
import { formatNumber } from '../../../helpers/formatNumber';
import { Cell } from './Cell';
const DisplayNote = styled.div `
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.secondary.blendToBackground(800)};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
const StyledAmountInput = styled(AmountInput) `
  --input-background: transparent;
  --input-color: ${({ theme }) => theme.foreground};

  border-radius: var(--table-cell-border-radius);
  box-shadow: 0 0 0 var(--input-inline-outline, 0px)
    var(--input-inline-outline-color, ${({ theme }) => theme.primary.background});
  position: relative;

  &:hover {
    --input-inline-outline: 1px;
    --input-inline-outline-color: ${({ theme }) => theme.primary.background};
  }

  &:focus,
  &:focus-within {
    --input-inline-outline: 1px;

    z-index: 3;
  }
`;
const DisplayCell = styled(Cell) `
  color: ${({ theme, $isAdding }) => ($isAdding === true ? theme.success.background : theme.foreground)};

  ${({ $isAdding }) => $isAdding === false &&
    css `
      position: relative;

      &:before {
        content: '-';
        position: absolute;
        right: 100%;
        display: block;
        top: -1px;
        font: inherit;
        line-height: inherit;
        z-index: 10;
      }
    `}

  ${({ $isBold }) => $isBold &&
    css `
      font-weight: 500;
    `}
`;
const AmountDisplayCell = ({ currencyCode, isBold, isColorized, note, value, }) => {
    const amount = useMemo(() => formatNumber(value, currencyCode), [currencyCode, value]);
    return (React.createElement(DisplayCell, { "$isBold": isBold, "$isAdding": isColorized && value ? value >= 0 : undefined },
        amount,
        note && React.createElement(DisplayNote, null, note)));
};
const AmountInputCell = (props) => {
    return React.createElement(StyledAmountInput, { ...props, currencyList: props.currencyList });
};
export const AmountCell = ({ isEditable, ...props }) => {
    return isEditable ? React.createElement(AmountInputCell, { ...props }) : React.createElement(AmountDisplayCell, { ...props });
};
//# sourceMappingURL=AmountCell.js.map